import { render, staticRenderFns } from "./JscConfigurationEdit.vue?vue&type=template&id=9190e2b6&"
import script from "./JscConfigurationEdit.vue?vue&type=script&lang=js&"
export * from "./JscConfigurationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports